module.exports = __webpack_public_path__ + "media/scholarship_winners/corinna-sw-01026156.png";